var _line, _line2, _rect, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c1d44725-6ba4-4539-afd3-61acc0e00158",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "ecc7eb7b-f269-4357-9488-c0c6fba3647a",
    "data-name": "<Path>",
    x1: 68,
    y1: 20,
    x2: 68,
    y2: 44,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "6ec71f7c-7451-40ac-844c-937cf1a0ed5e",
    "data-name": "<Path>",
    x1: 124,
    y1: 20,
    x2: 124,
    y2: 44,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 36,
    width: 136,
    height: 136,
    rx: 12,
    ry: 12,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 68,
    x2: 28,
    y2: 68,
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 116,
    x2: 44,
    y2: 116,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 116,
    x2: 84,
    y2: 116,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: 116,
    x2: 124,
    y2: 116,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 92,
    x2: 44,
    y2: 92,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 92,
    x2: 84,
    y2: 92,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: 92,
    x2: 124,
    y2: 92,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 140,
    x2: 44,
    y2: 140,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: 140,
    x2: 84,
    y2: 140,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: 140,
    x2: 124,
    y2: 140,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e9fc34ac575e3c2c1e656ec2b97a4137.svg";
export { ForwardRef as ReactComponent };